"use client";

import { useState } from "react";

/**
 * Inline email-capture form for the Anchor early-access waitlist (Compass marketing page).
 * Posts to /api/anchor/waitlist; shows an inline success/error message. No auth.
 */
export function AnchorWaitlistForm() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "busy" | "done" | "error">("idle");
  const [msg, setMsg] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (state === "busy") return;
    setState("busy");
    setMsg(null);
    try {
      const res = await fetch("/api/anchor/waitlist", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source: "compass_marketing" }),
      });
      const d = await res.json().catch(() => ({}));
      if (res.ok) {
        setState("done");
        setMsg("You're on the list. We'll be in touch.");
      } else {
        setState("error");
        setMsg(d.error ?? "Please try again.");
      }
    } catch {
      setState("error");
      setMsg("Network error. Please retry.");
    }
  };

  if (state === "done") {
    return (
      <p style={{ color: "var(--color-blue-2)", fontSize: 15, marginTop: 8 }}>
        ✓ {msg}
      </p>
    );
  }

  return (
    <form onSubmit={submit} style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 8, maxWidth: 460 }}>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@email.com"
        aria-label="Email for Anchor early access"
        style={{
          flex: "1 1 220px",
          background: "var(--color-bg)",
          border: "1px solid var(--color-line)",
          borderRadius: 10,
          padding: "12px 14px",
          fontSize: 15,
          color: "var(--color-text)",
        }}
      />
      <button
        type="submit"
        disabled={state === "busy"}
        style={{
          background: "var(--color-blue-2)",
          color: "#fff",
          border: "none",
          borderRadius: 10,
          padding: "12px 22px",
          fontSize: 15,
          fontWeight: 600,
          cursor: state === "busy" ? "default" : "pointer",
          opacity: state === "busy" ? 0.6 : 1,
          whiteSpace: "nowrap",
        }}
      >
        {state === "busy" ? "…" : "Request access"}
      </button>
      {msg && state === "error" && (
        <span style={{ flexBasis: "100%", color: "var(--color-gold)", fontSize: 13 }}>{msg}</span>
      )}
    </form>
  );
}
